export type { HeadingProps } from "./Heading.interface";
export { Heading } from "./Heading";